import createThreadedCounter from 'common/utils/createThreadedCounter';

const notificationThreadCount = createThreadedCounter();
export default notificationThreadCount;
